import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './wooden_staff.png'

export const wooden_staff: ItemUI<Weapon> = {
    image,
    label: 'Wooden staff',
    value: 15,
    item: {
        key: 'wooden_staff',
        type: 'weapon',
        rarity: ItemRarity.Epic,
        stats: {
            intelligence: 20,
            health: 10
        },
        two_handed: true,
        category: 'staff',
        damageType: DamageType.Melee,
        range: AttackRange.Melee,
        energy: 2,
        damage: 6
    }
}
